module.exports = __webpack_public_path__ + "img/icon-qxywxt.e5b34043.png";